import axios from 'axios'

const axiosClient = axios.create({
  baseURL: process.env.REACT_APP_SERVER_ADDRESS,
})

export default axiosClient
